import type { Arrayable } from 'element-plus/es/utils'
import { storeToRefs } from 'pinia'
import { ensureArray, isNilOrEmpty } from 'ramda-adjunct'
import { useProfileStore } from '../store'
import { permissionMatcher } from '../types'

export function usePermission() {
  const { permissions, isSuper } = storeToRefs(useProfileStore())

  function checkPermission(permission: Arrayable<string>) {
    if (isSuper.value) {
      // 超级管理员在前端直接拥有所有权限，避免路由守卫早于 App 初始化 scope 时误判。
      return true
    }

    const permissionsToTest = ensureArray(permission)
    if (isNilOrEmpty(permissionsToTest)) {
      return false
    }

    return permissionsToTest.some((p) => {
      return permissions.value.some(permissionMatcher(p))
    })
  }

  return {
    checkPermission,
  }
}
